import type { ClientView } from '@gazette/shared';
import { t } from '../../i18n/index.ts';
import { actions } from '../../net/client.ts';
import { ErrorNotice, GameHeader } from '../components/Chrome.tsx';
import { Headline } from '../components/Clipping.tsx';
import { Icon } from '../components/Icon.tsx';
import { Progress } from '../components/Progress.tsx';
import type { PhaseOf } from '../hooks.ts';

export function Plume({ current, phase }: { current: ClientView; phase: PhaseOf<'plume'> }) {
  const own = new Set(phase.ownArticleIds);
  return (
    <>
      <GameHeader />
      <section class="sheet sheet--full" data-occlude aria-labelledby="plume-title">
        <h2 id="plume-title" class="sheet__title">
          <Icon name="quill" size={28} />
          {t('plume.title')}
        </h2>
        <p class="sheet__intro">{t('plume.body')}</p>
        <ul class="plume-list">
          {current.gazette!.articles.map((article) => {
            const mine = own.has(article.id);
            const chosen = phase.vote === article.id;
            return (
              <li key={article.id}>
                <button
                  type="button"
                  class="plume-pick"
                  aria-pressed={chosen}
                  disabled={mine}
                  onClick={() => void actions.plume(article.id)}
                  aria-label={mine ? `${article.headline} (${t('plume.own')})` : undefined}
                >
                  <span class="plume-pick__number">{t('gz.edition', { n: article.number })}</span>
                  <span class="plume-pick__headline">
                    <Headline kicker={article.kicker} headline={article.headline} />
                  </span>
                  {mine && <span class="plume-pick__note">{t('plume.own')}</span>}
                  {chosen && (
                    <span class="plume-pick__note plume-pick__note--chosen">
                      <Icon name="quill" size={16} />
                      {t('plume.voted')}
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
        <ErrorNotice />
        <Progress progress={phase.progress} label={t('progress.plume', phase.progress)} />
      </section>
    </>
  );
}
